import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import SimpleFilterApp from '../SearchFilterV2/SimpleFilterApp';

class SimpleFilter extends Component {
  render() {
    const {
      filterCategories,
      filterModels,
      sortOptions,
      showDropdownIcon,
      showActiveStatus,
      showDropdownCloseButtons,
      showClearFiltersButton,
      filterButtonTitle,
      filterButtonIcon,
      sortButtonTitle,
      sortButtonIcon,
    } = this.props;

    return (
      <SimpleFilterApp
        fieldSuggestion="name"
        fieldKeywordFilter="q[name_cont]"
        fieldCategoryFilter="q[categories_name_in][]"
        fieldModelFilter="q[models_name_in][]"
        filterCategories={filterCategories}
        filterModels={filterModels}
        sortOptions={sortOptions}
        showDropdownIcon={showDropdownIcon}
        showActiveStatus={showActiveStatus}
        filterButtonTitle={filterButtonTitle}
        filterButtonIcon={filterButtonIcon}
        sortButtonTitle={sortButtonTitle}
        sortButtonIcon={sortButtonIcon}
        showDropdownCloseButtons={showDropdownCloseButtons}
        showClearFiltersButton={showClearFiltersButton}
      />
    );
  }
}

SimpleFilter.defaultProps = {
  showDropdownCloseButtons: false,
  showClearFiltersButton: false,
  showDropdownIcon: false,
  showActiveStatus: false,
  filterButtonTitle: 'Filtrar',
  sortButtonTitle: 'Ordenar',
  filterButtonIcon: 'icon-chevron',
  sortButtonIcon: 'icon-chevron',
};

SimpleFilter.propTypes = {
  filterCategories: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  filterModels: PropTypes.array,
  showDropdownIcon: PropTypes.bool,
  showActiveStatus: PropTypes.bool,
  sortOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      paramValue: PropTypes.string,
    }),
  ),
  filterButtonTitle: PropTypes.string,
  sortButtonTitle: PropTypes.string,
  filterButtonIcon: PropTypes.string,
  sortButtonIcon: PropTypes.string,
  showDropdownCloseButtons: PropTypes.bool,
  showClearFiltersButton: PropTypes.bool,
};

export default SimpleFilter;
